import { fetch } from "src/services/apollo-fetch";
import { Query } from "./_api";

export default {
    async getSavedPaymentInfo() {
        const response = await fetch.query({
            query: Query.savedPaymentInfo,
        });
        return response.data.savedPaymentInfo;
    },
    async getPaymentIntent(actions, data) {
        const response = await fetch.query({
            query: Query.getPaymentIntent,
            variables: data,
        });
        return response.data.getPaymentIntent;
    },
    setInvoicesPerPage({ commit }, data) {
        commit("setInvoicesPerPage", data);
    },
    setPaidInvoicesPerPage({ commit }, data) {
        commit("setPaidInvoicesPerPage", data);
    },
};
